import {ServiceRequest} from "../utils/service-request"
import {
    MOTOR_CADASTRO_PATH,
} from "../utils/api-routes"

class MotorParametrosService {

    constructor() {
        this.request = new ServiceRequest()
    }

    async loadCadastrosParametros(cetip, versao) {
        const params = new URLSearchParams()

        if (cetip) params.append("CETIP", cetip)
        if (versao) params.append("VersaoDocumento", versao)
        const query = params.toString() ? `?${params.toString()}` : ""

        return this.request.get(`${MOTOR_CADASTRO_PATH}/parametros${query}`)
    }
}

export default MotorParametrosService